import React, { useEffect, useState } from "react";
import axios from "axios";
import { Alert, Button, Carousel, Flex, message, Tooltip } from "antd";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentAdmin } from "@/redux/auth/selectors";
import BalloonsEffect from "../baloonEffects/BaloonEffect";

const API_URL = "/announcements-feeds";

const categoryGifs = {
    Alert: "https://media.giphy.com/media/YI3Q0ialYipRhBJG5N/giphy.gif?cid=790b7611kgy0bgrudhq53o3natho3toxya4akup572au4wr7&ep=v1_stickers_search&rid=giphy.gif&ct=s",
    Holiday: "https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExNjQ2NmM4aDJyNWljY2h6c3Y3MjVvcTc2ajk0OGExbTR6Z2c2YnhscSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/YmYTKkNaWU2FGDDxEz/giphy.gif"
};

const AnnouncementBanner = () => {
    const [announcements, setAnnouncements] = useState([]);
    const [readAnnouncements, setReadAnnouncements] = useState(new Set());
    const currentAdmin = useSelector(selectCurrentAdmin);
    console.log(announcements, 'announcements');
    useEffect(() => {
        let isMounted = true;

        const fetchAnnouncements = async () => {
            try {
                const { data } = await axios.get(API_URL);
                let filteredAnnouncements = data?.filter(a => {
                     let matched = (a.isVisible && !a.hasRead.includes(currentAdmin?._id))
                     return matched;
                    })
                setAnnouncements([]);
            } catch (error) {
                console.error("Failed to fetch announcements", error);
            } finally {
                if (isMounted) {
                    setTimeout(fetchAnnouncements, 300000);
                }
            }
        };

        fetchAnnouncements();

        return () => {
            isMounted = false;
        };
    }, []);

    const markAsRead = async (id) => {
        try {
            await axios.get(`/announcement-markasread/${id}`);
            message.success("Announcement marked as read!");
            setAnnouncements((prev) => prev.filter(item => item._id !== id)); // ✅ remove locally
        } catch (error) {
            console.error("Failed to mark as read:", error);
            message.error("Failed to mark announcement as read.");
        }
    };
    return (
        <>

            <Carousel autoplay key={announcements.length} autoplaySpeed={3000} style={{ display: announcements?.length ? 'block' : 'none', marginTop: 30, maxWidth: 900, margin: "auto", marginBottom: 20, height: 80 }}>
                {announcements.map((item) => (
                    <Flex key={item._id} style={{ position: "relative", flexDirection: 'row', alignItems: 'center', padding: 10 }}>
                        <Alert
                            message={
                                <Flex align="center" gap={10}>
                                    <Tooltip
                                        title={`🎂${item.message}`}
                                        overlayInnerStyle={{
                                            width: '300px',
                                            backgroundColor: '#333',
                                            color: '#fff',
                                            fontSize: '14px',
                                            lineHeight: '1.5'
                                        }}
                                    >
                                        <span>
                                            {item.category === 'Birthday' ? (
                                                `🎂${item.message.slice(0, 150)}`
                                            ) : (
                                                item.message.slice(0, 150)
                                            )}
                                            {item.message.length > 150 && '...'}
                                        </span>
                                    </Tooltip>
                                    <img
                                        src={categoryGifs[item.category === 'Birthday' || item.category === 'Holiday'? 'Holiday': 'Alert']}
                                        alt="Announcement GIF"
                                        style={{ width: 40, height: 40 }}
                                    />
                                </Flex>}
                            // type={item.priority === "High" ? "error" : item.priority === "Medium" ? "warning" : "info"}
                            style={{
                                flex: 1,
                                // background: readAnnouncements.has(item._id) ? "#d4edda" : item.priority === "High" ? "#f8d7da" : item.priority === "Medium" ? "#fff3cd" : "#d1ecf1",
                                // borderColor: readAnnouncements.has(item._id) ? "#c3e6cb" : item.priority === "High" ? "#f5c6cb" : item.priority === "Medium" ? "#ffeeba" : "#bee5eb",
                            }}
                            closeIcon={
                                <>
                                    <Button
                                        size="small"
                                        onClick={() => markAsRead(item._id)}
                                        style={{ background: '#1677ff', color: 'white', border: 'none' }}
                                    >
                                        Mark as Read
                                    </Button>
                                    <Button
                                        size="small"
                                        style={{ marginLeft: 3, background: '#1677ff', color: 'white', border: 'none' }}
                                    >
                                        <Link to='/announcement-feeds'>All</Link>
                                    </Button>
                                </>
                            }
                        />
                        <BalloonsEffect trigger={item.category === "Holiday" || item.category === "Birthday"} />
                    </Flex>
                ))}
            </Carousel> 

        </>

    );
};

export default AnnouncementBanner;
